import { Component, OnInit, Input, ViewChild, ViewContainerRef, ComponentRef, ComponentFactory, ComponentFactoryResolver } from '@angular/core';
import { NodoEntity, FiltrosFormatoAsistencialEntity, FormatoAsistencialEntity } from '../../../../../services/servicio-formato-asistencial.service';
import { FilaComponent } from '../../fila/fila.component';

@Component({
  selector: 'app-acordion-tab',
  templateUrl: './acordion-tab.component.html',
  styleUrls: ['./acordion-tab.component.css']
})
export class AcordionTabComponent implements OnInit {

  @Input() data: FormatoAsistencialEntity;
  @Input() nodo: NodoEntity;
  @Input() filtros: FiltrosFormatoAsistencialEntity;
  @ViewChild('acordionTabContainer', { read : ViewContainerRef}) container: ViewContainerRef;

  titulo: string;
  items: number;

  constructor( private componentFactory: ComponentFactoryResolver) { }

  ngOnInit() {
    if (this.nodo) {
      this.onProcess();
    } else {
      this.titulo = '';
    }
  }

  onProcess() {
    this.titulo = this.nodo.titulo;
    this.items = 0;
    if (this.nodo.hijos && this.nodo.hijos.length > 0) {
      this.buildFormato(this.nodo.hijos);
    }
  }

  buildFormato(nodos: NodoEntity[]) {    
    nodos = nodos.sort((a: NodoEntity, b: NodoEntity) =>  a.orden - b.orden);
    let row: ComponentRef<FilaComponent> = null;
    let start = false;
    let index = -1;
    nodos.forEach((n: NodoEntity) => {
      if (n.impresion) {
        const orientacion = n.codigoOrientacion;
      if (orientacion === 1) {
        if (row) {
          row.instance.nodos.push(n);
          if (start) {
            start = false;
            row = null;
          }
        } else {
          this.items++;
          index++;
          row = this.getRow(index);
          row.instance.nodos.push(n);
          start = true;
        }
      } else if (orientacion === 2) {
        this.items++;
        index++;
        row = this.getRow(index);
        row.instance.nodos.push(n);
        start = false;
        row = null;
      }
      }
    });
  }

  getRow(index: number): ComponentRef<FilaComponent> {
    const factory: ComponentFactory<FilaComponent> = this.componentFactory.resolveComponentFactory(FilaComponent);
    const component: ComponentRef<FilaComponent> = this.container.createComponent(factory);
      component.instance.filtros = this.filtros;
      component.instance.data = this.data;
      component.instance.index = index;
      component.instance.onDelete = () => {
        this.onDetach(component);
      };
    return component;
  }

  onDetach(component: any) {
    const index = this.container.indexOf(component);
    this.container.remove(index);
    this.items--;
    if (this.items === 0) {
      setTimeout(() => {
        this.onDelete();
      }, 50);
    }
  }

  onDelete() { }
}
